import React from "react";
import { Tooltip } from "../../../../design_system/components/ToolTip/ToolTip";
import { Icons } from "../../../../design_system/components/Icons";

const PresetOption = ({
  preset,
  isActive,
  onSelectPreset,
  smartPublishData = {},
}) => {
  const showInfo =
    preset.key === "last_published_on" &&
    smartPublishData.last_published_by &&
    smartPublishData.last_published_on;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onSelectPreset(preset);
      }}
      className={`body-s-bold cursor-pointer flex items-center relative preset-option${isActive ? " preset-option--active" : ""}`}
    >
      {preset.label}

      {showInfo && (
        <Tooltip
          tooltipText={() => (
            <div
              className="body-s text-center preset-option__tooltip-content"
            >
              Last published by{" "}
              <span className="preset-option__tooltip-name">
                {smartPublishData.last_published_by}
              </span>
              <br />
              on{" "}
              <span className="preset-option__tooltip-name">
                {smartPublishData.last_published_on}
              </span>
            </div>
          )}
          showWithoutOverflowing
          placement="bottom"
        >
          <span className="inline-flex items-center preset-option__info-icon">
            <Icons name="info" size={16} />
          </span>
        </Tooltip>
      )}

      {isActive && (
        <Icons name="check" size={16} className="preset-option__check" />
      )}
    </div>
  );
};

export { PresetOption };
